import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { GiBreakingChain } from "react-icons/gi";

const NotFound = ({ title }) => {
  const history = useHistory();
  return (
    <div className='page-not-found' >
      <GiBreakingChain style={{ fontSize: '90px', marginBottom: '30px' }} />
      <h1>404 {title ? title : "Page Not Found"}</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <button className="btn btn-custom-gradient px-5 text-uppercase mb-2 px-4 py-lg-2 shadow-sm" onClick={() => history.push("/")}>
        Go to Home
      </button>
    </div>
  )
}

export default NotFound